export default "__VITE_ASSET__88e0fe5d__"